import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Col, Container, Row } from "react-bootstrap";
import SearchInput from "../../Components/SearchInput";
import SearchableSelect from "../../Components/SearchableSelect";
import customloader from "../../assets/images/RollingLoader.gif";
import NoResult from "../../Components/NoResult";
import CustomizeTableview from "../../Components/TableViews/CustomizeTableview";
import PaginationBar from "../../Components/PaginationBar";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";
import PopUpModal from "../../Components/Modal";
import { toast } from "react-toastify";
const ShopFeatures = () => {
  const { user } = useSelector((state) => state.auth);
  const Changed4uStatusCall = useApi(postapi.Changed4uStatus, { hasCatchError: true });
  const GetGlobalFeaturesCall = useApi(api.getGlobalFeatures, { hasCatchError: true });
  const fetchAllShopsCall = useApi(api.fetchAllShops, { hasCatchError: true });
  const fetchCities = useApi(api.getCities, { hasCatchError: true });

  let [shops, setShops] = useState([]);
  let [isLoading, setIsLoading] = useState([]);
  const [noOfPages, setNoOfPages] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toggle, refresh] = useState(false);
  const [orderBy, setOrderBy] = useState({ shop_registered_at: "DESC" });
  const [searchInput, setSearchInput] = useState("");
  const [status, setStatus] = useState({ value: null, label: "All Shops" });
  const [d4u, setD4u] = useState({ value: undefined, label: "All Statuses" });
  const [error, setError] = useState("");
  const [enableDisableModalShow, setEnableDisableModalShow] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [shopData, setShopData] = useState({});
  const [featureStates, setFeatureStates] = useState({
    is_d4u_enabled: 0,
    is_pg_enabled: 0,
    is_bnpl_enabled: 0
  });
  const [city, setCity] = useState({ value: null, label: "All Cities" });
  const [cityName, setCityName] = useState([]);
  const [globalFeatures, setGlobalFeatures] = useState({
    is_d4u_enabled: false,
    is_pg_enabled: false,
    is_bnpl_enabled: false
  });
  const [globalModalShow, setGlobalModalShow] = useState(false);
  const [globalFeatureStates, setGlobalFeatureStates] = useState({
    is_d4u_enabled: 0,
    is_pg_enabled: 0,
    is_bnpl_enabled: 0
  });
  const [isGlobalClicked, setIsGlobalClicked] = useState(false);

  const searchFilter = (e) => {
    e.preventDefault();
    if (e.target.value === "") {
      setSearchInput("");
    } else {
      setSearchInput(e.target.value);
    }
  };
  const resetFilterHandle = () => {
    setSearchInput("");
    setSizeOfPages(10);
    setStatus({ value: null, label: "All Shops" });
    setD4u({ value: undefined, label: "All Statuses" });
    setCity({ value: null, label: "All Cities" });
  };

  const handlePageSize = (e) => {
    setSizeOfPages(e.value);
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };

  const fetchAllShopsRequests = async () => {
    try {
      const res = await fetchAllShopsCall.request({
        size: sizeOfPages,
        page: currentPage,
        search: searchInput,
        orderBy: orderBy,
        status: status.value,
        d4u: d4u.value,
        city: city.value,
      });
      const data = res?.data?.data;
      setIsLoading(false);
      if (data) {
        // Transform shop data to display Enabled/Disabled for feature flags
        const transformedShops = data.shops.map(shop => ({
          ...shop,
          d4u_status: shop.is_d4u_enabled === 1 ? 'Enabled' : 'Disabled',
          pg_status: shop.is_pg_enabled === 1 ? 'Enabled' : 'Disabled',
          bnpl_status: shop.is_bnpl_enabled === 1 ? 'Enabled' : 'Disabled',
        }));
        setShops(transformedShops);
        setCount(data?.pagination?.no_of_items);
        if (data?.pagination?.no_of_pages === 0) {
          setNoOfPages(0);
        } else {
          setNoOfPages(data?.pagination?.no_of_pages);
          if (currentPage > data?.pagination?.no_of_pages) {
            setCurrentPage(data?.pagination?.no_of_pages);
          }
        }
      } else {
        setShops([]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllShopsRequests();
  }, [currentPage, sizeOfPages, searchInput, toggle, status, orderBy, d4u, city]);

  useEffect(() => {
    if (currentPage === 1) {
      refresh((prev) => !prev);
    } else {
      changePage(1);
    }
  }, [searchInput, status, d4u, city]);
  const handleStatus = (e) => {
    if (e.label === "All Shops") {
      setStatus({ value: null, label: "All Shops" });
    } else {
      setStatus({ value: e.value, label: e.label });
    }
  };

  const handled4uStatus = (e) => {
    if (e.label === "All Statuses") {
      setD4u({ vale: undefined, label: e.label });
    } else {
      setD4u({ value: e.value, label: e.label });
    }
  };

  const handleEnableDisable = (data) => {
    setEnableDisableModalShow(true);
    setShopData(data);
    setFeatureStates({
      is_d4u_enabled: data.is_d4u_enabled || 0,
      is_pg_enabled: data.is_pg_enabled || 0,
      is_bnpl_enabled: data.is_bnpl_enabled || 0
    });
  };

  const toggleFeature = (feature) => {
    setFeatureStates(prev => {
      const newStates = { ...prev };
      
      if (feature === 'is_d4u_enabled') {
        // If disabling D4U, cascade disable PG and BNPL
        if (prev.is_d4u_enabled === 1) {
          newStates.is_d4u_enabled = 0;
          newStates.is_pg_enabled = 0;
          newStates.is_bnpl_enabled = 0;
        } else {
          newStates.is_d4u_enabled = 1;
        }
      } else if (feature === 'is_pg_enabled') {
        // If disabling PG, cascade disable BNPL
        if (prev.is_pg_enabled === 1) {
          newStates.is_pg_enabled = 0;
          newStates.is_bnpl_enabled = 0;
        } else {
          // Can only enable PG if D4U is enabled
          if (prev.is_d4u_enabled === 1) {
            newStates.is_pg_enabled = 1;
          }
        }
      } else if (feature === 'is_bnpl_enabled') {
        // Can only toggle BNPL if both D4U and PG are enabled
        if (prev.is_bnpl_enabled === 1) {
          newStates.is_bnpl_enabled = 0;
        } else {
          if (prev.is_d4u_enabled === 1 && prev.is_pg_enabled === 1) {
            newStates.is_bnpl_enabled = 1;
          }
        }
      }
      
      return newStates;
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsClicked(true);
      
      // Single PATCH call with all features as key:boolean
      const response = await Changed4uStatusCall.request({ 
        shopId: shopData["shop_id"], 
        is_d4u_enabled: featureStates.is_d4u_enabled === 1,
        is_pg_enabled: featureStates.is_pg_enabled === 1,
        is_bnpl_enabled: featureStates.is_bnpl_enabled === 1
      });
      
      if (response.status === 200) {
        toast.success('Features updated successfully', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        refresh((prev) => !prev);
        close();
      }
    } catch (error) {
      setError(error?.response?.data?.error?.message || 'Failed to update features');
      setIsClicked(false);
    }
  };
  const close = () => {
    setEnableDisableModalShow(false);
    setShopData({});
    setError(null);
    setIsClicked(false);
    setFeatureStates({
      is_d4u_enabled: 0,
      is_pg_enabled: 0,
      is_bnpl_enabled: 0
    });
  };
  const getCities = async () => {
    return new Promise((resolve, reject) => {
      fetchCities
        .request()
        .then((res) => {
          const getData = res.data.map((cat) => ({
            value: cat.city_id,
            label: cat.city_name,
          }));
          setCityName(getData);
          resolve(getData);
        })
        .catch((err) => {
          reject("err" + err);
        });
    });
  };
  useEffect(() => {
    getCities();
    fetchGlobalFeatures();
  }, []);

  const fetchGlobalFeatures = async () => {
    try {
      const res = await GetGlobalFeaturesCall.request();
      
      
      // Handle potentially nested data structure
      const responseData = res?.data?.data || res?.data;
      
      if (responseData) {
        const features = {
          is_d4u_enabled: responseData.d4u_enabled || false,
          is_pg_enabled: responseData.pg_enabled || false,
          is_bnpl_enabled: responseData.bnpl_enabled || false
        };
        setGlobalFeatures(features);
      }
    } catch (error) {
      console.log('Failed to fetch global features', error);
    }
  };

  const openGlobalModal = () => {
    const states = {
      is_d4u_enabled: globalFeatures.is_d4u_enabled ? 1 : 0,
      is_pg_enabled: globalFeatures.is_pg_enabled ? 1 : 0,
      is_bnpl_enabled: globalFeatures.is_bnpl_enabled ? 1 : 0
    };
    setGlobalModalShow(true);
    setGlobalFeatureStates(states);
  };

  const closeGlobalModal = () => {
    setGlobalModalShow(false);
    setError(null);
    setIsGlobalClicked(false);
    setGlobalFeatureStates({
      is_d4u_enabled: 0,
      is_pg_enabled: 0,
      is_bnpl_enabled: 0
    });
  };

  const toggleGlobalFeature = (feature) => {
    setGlobalFeatureStates(prev => {
      const newStates = { ...prev };
      
      if (feature === 'is_d4u_enabled') {
        if (prev.is_d4u_enabled === 1) {
          newStates.is_d4u_enabled = 0;
          newStates.is_pg_enabled = 0;
          newStates.is_bnpl_enabled = 0;
        } else {
          newStates.is_d4u_enabled = 1;
        }
      } else if (feature === 'is_pg_enabled') {
        if (prev.is_pg_enabled === 1) {
          newStates.is_pg_enabled = 0;
          newStates.is_bnpl_enabled = 0;
        } else {
          if (prev.is_d4u_enabled === 1) {
            newStates.is_pg_enabled = 1;
          }
        }
      } else if (feature === 'is_bnpl_enabled') {
        if (prev.is_bnpl_enabled === 1) {
          newStates.is_bnpl_enabled = 0;
        } else {
          if (prev.is_d4u_enabled === 1 && prev.is_pg_enabled === 1) {
            newStates.is_bnpl_enabled = 1;
          }
        }
      }
      
      return newStates;
    });
  };

  const handleGlobalSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsGlobalClicked(true);
      
      const response = await Changed4uStatusCall.request({ 
        is_d4u_enabled: globalFeatureStates.is_d4u_enabled === 1,
        is_pg_enabled: globalFeatureStates.is_pg_enabled === 1,
        is_bnpl_enabled: globalFeatureStates.is_bnpl_enabled === 1
      });
      
      if (response.status === 200) {
        toast.success('Global features updated successfully for all shops', {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        await fetchGlobalFeatures();
        refresh((prev) => !prev);
        closeGlobalModal();
      }
    } catch (error) {
      setError(error?.response?.data?.error?.message || 'Failed to update global features');
      setIsGlobalClicked(false);
    }
  };
  const filterCities = (e) => {
    if (e.value === null) {
      setCity({ value: null, label: "All" });
    } else {
      setCity({ value: e.value, label: e.label });
    }
  };
  return (
    <>
      <Container fluid>
        <Row className="">
          <Col xs="2" lg="2" className="d-none d-lg-inline">
            <SearchInput searchlogo handleChange={searchFilter} value={searchInput} />
          </Col>
          <Col xs="6" lg="2" className="">
            <SearchableSelect
              selectClassName={"bg-white"}
              placeholder="Filter Status"
              value={status}
              searchable={false}
              options={[
                { value: null, label: "All Shops" },
                { value: "paid", label: "Paid" },
                { value: "trial", label: "Trial" },
              ]}
              handleChange={handleStatus}
            />
          </Col>
          <Col xs="6" lg="2" className="">
            <SearchableSelect
              selectClassName={"bg-white"}
              placeholder="Filter Dru shops"
              value={d4u}
              searchable={false}
              options={[
                { value: undefined, label: "All Statuses" },
                { value: "true", label: "Enabled" },
                { value: "false", label: "Disabled" },
              ]}
              handleChange={handled4uStatus}
            />
          </Col>
          <Col xs lg="2" className="d-none d-lg-inline">
            <SearchableSelect placeholder="Filter City" value={city} searchable={false} options={cityName} handleChange={filterCities} />
          </Col>
          <Col xs="6" lg="2" className="">
            <SearchableSelect
              selectClassName={"bg-white"}
              placeholder={`Showing ${sizeOfPages}`}
              defaultValue={`Showing ${sizeOfPages}`}
              value={`Showing ${sizeOfPages}`}
              searchable={false}
              options={[
                { value: "10", label: "10" },
                { value: "20", label: "20" },
                { value: "30", label: "30" },
              ]}
              handleChange={handlePageSize}
            />
          </Col>
        </Row>
        <>
          <div className="pt-2 d-flex justify-content-between">
            <Button className="mt-3" size="sm" type="submit" style={{ fontSize: "14px" }} onClick={resetFilterHandle}>
              <span className="d-none d-lg-inline">Reset Filters</span>{" "}
            </Button>
              <div className=" align-items-center">
                
                <Button 
                  variant="primary" 
                  size="sm" 
                  onClick={openGlobalModal}
                  style={{ padding: '8px 20px' }}
                >
                  Manage Global Features
                </Button>
              </div>
          </div>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "70vh" }}>
              <img src={customloader} alt="customloader" width="100" height="100" />
            </div>
          ) : shops.length === 0 ? (
            <NoResult name="Shops" />
          ) : (
            <Row style={{ marginBottom: "-3rem" }} className="mt-3">
            
              <CustomizeTableview
                data={shops}
                columnNotShow={["is_d4u_enabled", "is_pg_enabled", "is_bnpl_enabled"]}
                sortColumn={["shop_id", "shop_name", "username", "shop_email", "shop_registered_at"]}
                datetimeColumn={["shop_registered_at"]}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
                
                
                collapsableColumns={[
                  {
                    heading: "PG Status",
                    style: (row) => {
                      return row["is_pg_enabled"] === 1 ? "text-success fw-bold text-success" : "text-muted text-danger";
                    },
                    format: (row) => {
                      return row["pg_status"];
                    },
                  },
                  {
                    heading: "BNPL Status",
                    style: (row) => {
                      return row["is_bnpl_enabled"] === 1 ? "text-success fw-bold" : "text-muted";
                    },
                    format: (row) => {
                      return row["bnpl_status"];
                    },
                  }
                ]}
                toggleActionButton={
                  (user.user_type === "super-admin" || user.user_type === "admin") && {
                    label: (data) => "Edit",
                    onClick: (data) => {
                      handleEnableDisable(data);
                    },
                    variant: (data) => "outline-primary",
                    style: { padding: "8px", fontSize: "12px" },
                    column: "is_d4u_enabled",
                  }
                }
              />
              <Row className="mt-5">
                <Col className="d-none d-lg-block" md="6" lg="3">
                  <span className="text-secondary fs-6">{count} result(s)</span>
                </Col>
                <Col xs="12" lg="6">
                  <PaginationBar noOfPages={noOfPages} currentPage={currentPage} changePage={changePage} />
                </Col>
                <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
                  <span className="text-secondary fs-6">{count} result(s)</span>
                </Col>
                <Col xs="6" lg="3" className="text-end mt-3"></Col>
              </Row>
            </Row>
          )}
        </>
        <PopUpModal title={`Manage Features - ${shopData["shop_name"]}`} show={enableDisableModalShow} onHide={close} closeButton={false}>
          <>
            {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}

            <div className="pb-3">
              <div className="mb-3" style={{ fontSize: '13px', color: '#6c757d' }}>
                Configure features for this shop. Note: PG requires D4U, BNPL requires both D4U and PG.
              </div>
              
              <div className="d-flex flex-column gap-3">
                {/* D4U Feature */}
                <div 
                  className="p-3 border rounded" 
                  style={{ 
                    backgroundColor: featureStates.is_d4u_enabled ? '#d4edda' : '#f8f9fa',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onClick={() => toggleFeature('is_d4u_enabled')}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Deliver for You (D4U)</strong>
                      <div style={{ fontSize: '12px', color: '#6c757d' }}>Base delivery feature</div>
                    </div>
                    <div className={`fw-bold ${featureStates.is_d4u_enabled ? 'text-success' : 'text-danger'}`}>
                      {featureStates.is_d4u_enabled ? '✓ Enabled' : '✗ Disabled'}
                    </div>
                  </div>
                </div>

                {/* PG Feature */}
                <div 
                  className="p-3 border rounded" 
                  style={{ 
                    backgroundColor: featureStates.is_pg_enabled ? '#d4edda' : '#f8f9fa',
                    cursor: featureStates.is_d4u_enabled ? 'pointer' : 'not-allowed',
                    opacity: featureStates.is_d4u_enabled ? 1 : 0.6,
                    transition: 'all 0.2s'
                  }}
                  onClick={() => toggleFeature('is_pg_enabled')}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Payment Gateway (PG)</strong>
                      <div style={{ fontSize: '12px', color: '#6c757d' }}>
                        Requires D4U {!featureStates.is_d4u_enabled && '⚠️'}
                      </div>
                    </div>
                    <div className={`fw-bold ${featureStates.is_pg_enabled ? 'text-success' : 'text-muted'}`}>
                      {featureStates.is_pg_enabled ? '✓ Enabled' : '✗ Disabled'}
                    </div>
                  </div>
                </div>

                {/* BNPL Feature */}
                <div 
                  className="p-3 border rounded" 
                  style={{ 
                    backgroundColor: featureStates.is_bnpl_enabled ? '#d4edda' : '#f8f9fa',
                    cursor: (featureStates.is_d4u_enabled && featureStates.is_pg_enabled) ? 'pointer' : 'not-allowed',
                    opacity: (featureStates.is_d4u_enabled && featureStates.is_pg_enabled) ? 1 : 0.6,
                    transition: 'all 0.2s'
                  }}
                  onClick={() => toggleFeature('is_bnpl_enabled')}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Buy Now Pay Later (BNPL)</strong>
                      <div style={{ fontSize: '12px', color: '#6c757d' }}>
                        Requires D4U & PG {(!featureStates.is_d4u_enabled || !featureStates.is_pg_enabled) && '⚠️'}
                      </div>
                    </div>
                    <div className={`fw-bold ${featureStates.is_bnpl_enabled ? 'text-success' : 'text-muted'}`}>
                      {featureStates.is_bnpl_enabled ? '✓ Enabled' : '✗ Disabled'}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex gap-3 mt-3">
              <span
                className="w-100 d-flex justify-content-center align-items-center text-secondary p-2 border-2 border-secondary"
                style={{
                  cursor: "pointer",
                  border: "2px solid rgba(151, 156, 162, 1)",
                  borderRadius: "6px",
                }}
                onClick={() => close()}
              >
                Cancel
              </span>
              <Button className="w-100" onClick={handleSubmit} disabled={isClicked}>
                Save Changes
              </Button>
            </div>
          </>
        </PopUpModal>

        {/* Global Features Modal */}
        <PopUpModal title="Manage Global Features - All Shops" show={globalModalShow} onHide={closeGlobalModal} closeButton={false}>
          <>
            {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}

            <div className="pb-3">
              <div className="mb-3 p-2 bg-warning-subtle border border-warning rounded" style={{ fontSize: '13px' }}>
                <strong>⚠️ Warning:</strong> Changes will affect ALL shops in the system. This is a global setting.
              </div>
              
              <div className="d-flex flex-column gap-3">
                {/* D4U Feature */}
                <div 
                  className="p-3 border rounded" 
                  style={{ 
                    backgroundColor: globalFeatureStates.is_d4u_enabled ? '#d4edda' : '#f8f9fa',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onClick={() => toggleGlobalFeature('is_d4u_enabled')}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Deliver for You (D4U)</strong>
                      <div style={{ fontSize: '12px', color: '#6c757d' }}>Base delivery feature</div>
                    </div>
                    <div className={`fw-bold ${globalFeatureStates.is_d4u_enabled ? 'text-success' : 'text-danger'}`}>
                      {globalFeatureStates.is_d4u_enabled ? '✓ Enabled' : '✗ Disabled'}
                    </div>
                  </div>
                </div>

                {/* PG Feature */}
                <div 
                  className="p-3 border rounded" 
                  style={{ 
                    backgroundColor: globalFeatureStates.is_pg_enabled ? '#d4edda' : '#f8f9fa',
                    cursor: globalFeatureStates.is_d4u_enabled ? 'pointer' : 'not-allowed',
                    opacity: globalFeatureStates.is_d4u_enabled ? 1 : 0.6,
                    transition: 'all 0.2s'
                  }}
                  onClick={() => toggleGlobalFeature('is_pg_enabled')}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Payment Gateway (PG)</strong>
                      <div style={{ fontSize: '12px', color: '#6c757d' }}>
                        Requires D4U {!globalFeatureStates.is_d4u_enabled && '⚠️'}
                      </div>
                    </div>
                    <div className={`fw-bold ${globalFeatureStates.is_pg_enabled ? 'text-success' : 'text-muted'}`}>
                      {globalFeatureStates.is_pg_enabled ? '✓ Enabled' : '✗ Disabled'}
                    </div>
                  </div>
                </div>

                {/* BNPL Feature */}
                <div 
                  className="p-3 border rounded" 
                  style={{ 
                    backgroundColor: globalFeatureStates.is_bnpl_enabled ? '#d4edda' : '#f8f9fa',
                    cursor: (globalFeatureStates.is_d4u_enabled && globalFeatureStates.is_pg_enabled) ? 'pointer' : 'not-allowed',
                    opacity: (globalFeatureStates.is_d4u_enabled && globalFeatureStates.is_pg_enabled) ? 1 : 0.6,
                    transition: 'all 0.2s'
                  }}
                  onClick={() => toggleGlobalFeature('is_bnpl_enabled')}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>Buy Now Pay Later (BNPL)</strong>
                      <div style={{ fontSize: '12px', color: '#6c757d' }}>
                        Requires D4U & PG {(!globalFeatureStates.is_d4u_enabled || !globalFeatureStates.is_pg_enabled) && '⚠️'}
                      </div>
                    </div>
                    <div className={`fw-bold ${globalFeatureStates.is_bnpl_enabled ? 'text-success' : 'text-muted'}`}>
                      {globalFeatureStates.is_bnpl_enabled ? '✓ Enabled' : '✗ Disabled'}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex gap-3 mt-3">
              <span
                className="w-100 d-flex justify-content-center align-items-center text-secondary p-2 border-2 border-secondary"
                style={{
                  cursor: "pointer",
                  border: "2px solid rgba(151, 156, 162, 1)",
                  borderRadius: "6px",
                }}
                onClick={() => closeGlobalModal()}
              >
                Cancel
              </span>
              <Button className="w-100" onClick={handleGlobalSubmit} disabled={isGlobalClicked} variant="primary">
                Save Global Changes
              </Button>
            </div>
          </>
        </PopUpModal>
      </Container>
    </>
  );
};

export default ShopFeatures;
